// = Libs =
import { ChangeEvent, FC, useEffect, useState } from 'react';
import clsx from 'clsx';

// = Styles =
import classes from './file-uploader.module.scss';

// = Types =
import { FileModel, FileUploaderProps } from './file-uploader.types';

// = Components =
import File from './components/file';
import { assistantService } from '@/services/assistant/assistant.service';

const convertToFile = (items: FileList): FileModel[] => {
  return Array.from(items).map((el) => {
    return {
      name: el.name,
      type: el.name.split('.').reverse()[0],
      file: el,
    };
  });
};

const FileUploader: FC<
  FileUploaderProps & {
    fullWidth?: boolean;
    isNew?: boolean;
    initialId: number;
  }
> = (props) => {
  const {
    acceptExtensions,
    name,
    onChangeId,
    fullWidth,
    isNew,
    initialId = -1,
    disabled = false,
  } = props;

  const [file, setFile] = useState<FileModel>();
  const [fileId, setFileId] = useState(initialId);

  useEffect(() => {
    onChangeId && onChangeId(fileId);
  }, [fileId]);

  const handleChangeFile = (e: ChangeEvent<HTMLInputElement>) => {
    const files: FileList | null = e.target.files;

    const pushFile = async (f: any) => {
      setFileId(
        (await assistantService.sendFileToServer<{ fileId: number }>(f.file))
          ?.fileId || -1
      );
    };

    if (files && files.length) {
      const convertedFiles: FileModel[] = convertToFile(files);

      setFile(convertedFiles[0]);
      convertedFiles.forEach(pushFile);
    }
  };

  const handleRemoveFile = (name: string) => {
    setFile(undefined);
    setFileId(-1);
  };

  return (
    <label
      className={clsx({
        [classes['file']]: true,
        [classes['file--fullwidth']]: !!fullWidth,
      })}>
      {!file && (
        <input
          type="file"
          name={name}
          accept={acceptExtensions}
          className={classes['file__field']}
          onChange={handleChangeFile}
          disabled={disabled}
        />
      )}
      <div
        className={clsx({
          [classes['file__wrapper']]: true,
          [classes['file__wrapper--full']]: !!file,
        })}>
        <span className={classes['file__message']}>
          {!file &&
            (isNew
              ? 'Щелкните в эту область, чтобы загрузить файл'
              : ' Файл был загружен ранее. Щелкните, чтобы заменить его')}
        </span>

        {file && (
          <ul className={classes['file__list']}>
            <File
              key={`${file.name}`}
              name={file.name}
              type={(file.type as any) || 'pdf'}
              onRemove={handleRemoveFile}
            />
          </ul>
        )}
      </div>
    </label>
  );
};

export default FileUploader;
